interface TextSkeletonProps {
  lines?: number;
  message?: string;
  variant?: 'default' | 'gold';
}

export function TextSkeleton({ lines = 5, message, variant = 'default' }: TextSkeletonProps) {
  const widths = ['100%', '92%', '97%', '85%', '78%', '95%', '88%', '100%', '91%', '80%'];
  const lineClass = variant === 'gold' ? 'skeleton-gold' : 'skeleton-text';

  return (
    <div className="animate-fade-in">
      {message && (
        <p
          style={{
            color: variant === 'gold' ? 'var(--petrol)' : 'var(--text-tertiary)',
            fontSize: 'var(--text-label)',
            fontStyle: 'italic',
            marginBottom: '1.25rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.4rem',
          }}
        >
          {variant === 'gold' && <span style={{ animation: 'pulse 1.4s ease-in-out infinite' }}>✦</span>}
          {message}
        </p>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className={lineClass}
            style={{
              width: widths[i % widths.length],
              height: '1.1em',
              animationDelay: `${i * 100}ms`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
